<template>
  <section class="conversion-card">
    <div class="conversion-heading">
      <div>
        <h3>Conversion</h3>
        <p>Track this lead’s progress toward becoming a customer.</p>
      </div>
      <v-menu v-model="menu" offset-y bottom left :disabled="saving">
        <template v-slot:activator="{ on, attrs }">
          <button type="button" class="conversion-edit" v-bind="attrs" v-on="on" :disabled="saving" aria-label="Edit conversion status">
            <converted-badge :value="lead.is_converted" :status="lead.conversion_status" /><i class="mdi mdi-pencil-outline" aria-hidden="true"></i>
          </button>
        </template>
        <v-list dense>
          <v-subheader>Set conversion status</v-subheader>
          <v-list-item :disabled="saving" @click="save('converted')">
            <v-list-item-title>Converted</v-list-item-title>
            <v-list-item-action v-if="lead.is_converted == 1"><v-icon small>mdi-check</v-icon></v-list-item-action>
          </v-list-item>
          <v-list-item :disabled="saving" @click="save('in_contact')">
            <v-list-item-title>In Contact</v-list-item-title>
            <v-list-item-action v-if="lead.conversion_status === 'in_contact'"><v-icon small>mdi-check</v-icon></v-list-item-action>
          </v-list-item>
          <v-list-item :disabled="saving" @click="save('not_converted')">
            <v-list-item-title>Not Converted</v-list-item-title>
            <v-list-item-action v-if="lead.is_converted != 1 && lead.conversion_status !== 'in_contact'"><v-icon small>mdi-check</v-icon></v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <p v-if="saving || notice" class="conversion-notice" role="status" aria-live="polite">{{ saving ? 'Saving conversion status…' : notice }}</p>
    <v-alert v-if="error" dense type="error" role="alert">{{ error }}</v-alert>
  </section>
</template>

<script>
import axios from 'axios'
import ConvertedBadge from '@/components/common/ConvertedBadge.vue'

export default {
  name: 'LeadConversionStatus',
  components: { ConvertedBadge },
  props: { lead: { type: Object, required: true }, reportUuid: { type: String, default: '' } },
  data() { return { menu: false, saving: false, error: '', notice: '' } },
  methods: {
    async save(value) {
      if (this.saving) return
      this.menu = false
      this.saving = true
      this.error = ''
      this.notice = ''
      try {
        const endpoint = this.reportUuid ? 'public-lead-qualification' : 'lead-conversion'
        const payload = { lead_id: this.lead.id, conversion_status: value }
        if (this.reportUuid) Object.assign(payload, { report_uuid: this.reportUuid, field: 'conversion' })
        const { data } = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/${endpoint}`, payload,
          this.reportUuid ? {} : { headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt } })
        this.$emit('saved', data)
        this.notice = `Saved: ${data.is_converted ? 'Converted' : data.conversion_status === 'in_contact' ? 'In Contact' : 'Not Converted'}.`
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.message) || 'Could not save conversion status. Please try again.'
      } finally { this.saving = false }
    }
  }
}
</script>

<style scoped>
.conversion-card { border: 1px solid #e5e7eb; border-radius: 10px; background: #fff; padding: 16px; }
.conversion-heading { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.conversion-heading h3 { margin: 0 0 4px; font-size: 13px; font-weight: 700; color: #111827; }
.conversion-card p { margin: 0; font-size: 12px; line-height: 1.5; color: #6b7280; }
.conversion-edit { display: inline-flex; align-items: center; gap: 8px; padding: 5px; border: 1px solid transparent; border-radius: 8px; color: #6b7280; }
.conversion-edit:hover { border-color: #e5e7eb; background: #f9fafb; }
.conversion-edit:focus-visible { outline: 2px solid #276472; outline-offset: 3px; }
.conversion-edit:disabled { opacity: .55; cursor: not-allowed; }
.conversion-card .conversion-notice { margin-top: 12px; }
</style>
